import React, { Component } from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, Modal, Button } from 'react-bootstrap';

import { REST_API_URL } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import Combobox from '../Helper/Combobox';

/**
* Class InfoParcelle
* InfoParcelle view component
**/
class InfoParcelle extends Component {

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    let state = {object: {}, hidden: true};
    if(props.object instanceof Object) state.object = props.object;
    this.state = state;
    this.initialValue = cloneObject(state.object);
	}

  componentWillReceiveProps(props) {
    if(props.object) {
      let state = this.state;
      state.object = props.object;
      this.setState(state);
    }
  }

  /**
  * getObjectProperty
  * Returns the value for the current state's matching property
  **/
  getObjectProperty(property) {
    return (this.state.object !== undefined && this.state.object[property] !== undefined && this.state.object[property] !== null) ? this.state.object[property] : "";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const statutParcelle = this.getObjectProperty("statutParcelle");
    const idStatutParcelle = (statutParcelle instanceof Object) ? statutParcelle.idStatutParcelle : "";

    const motifParcelle = this.getObjectProperty("motifParcelle");
    const idMotifParcelle = (motifParcelle instanceof Object) ? motifParcelle.idMotifParcelle : "";

    const regimeJuridique = this.getObjectProperty("regimeJuridique");
    const idRegimeJuridique = (regimeJuridique instanceof Object) ? regimeJuridique.idRegimeJuridique : "";

    const sensibilite = this.getObjectProperty("sensibilite");
    const idSensibilite = (sensibilite instanceof Object) ? sensibilite.idSensibilite : "";

    const proprietaire = this.getObjectProperty("proprietaire");
    const idProprietaire = (proprietaire instanceof Object) ? proprietaire.idProprietaire : "";

    return(
      <Modal ref="modal" show={this.state.hidden === false} onHide={this.onHide.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Informations sur la parcelle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form horizontal>
            <FormGroup controlId="idInfoParcelle" className="customHidden">
              <Col componentClass={ControlLabel} sm={4}>Identifiant</Col>
              <Col sm={2}><FormControl type="text" value={this.getObjectProperty("idInfoParcelle")} disabled="true" /></Col>
            </FormGroup>

            <FormGroup controlId="idContrat">
              <Col componentClass={ControlLabel} sm={4}>Numéro de contrat</Col>
              <Col sm={2}><FormControl type="text" value={this.props.contrat.getObjectProperty("numero")} disabled="true" /></Col>
            </FormGroup>

            <FormGroup controlId="statutParcelle">
              <Col componentClass={ControlLabel} sm={4}>Statut</Col>
              <Col sm={6}><Combobox id="statutParcelle" url={REST_API_URL + "statutparcelle/"} optionValueKey="idStatutParcelle" optionLabelKey="libelle"
                default={idStatutParcelle} onChange={this.handleStatutParcelleSelect.bind(this)} placeholder="Statut" /></Col>
            </FormGroup>

            {(idStatutParcelle === 4) &&
              <FormGroup controlId="nomProjet">
                <Col componentClass={ControlLabel} sm={4}>Nom du projet</Col>
                <Col sm={6}><FormControl type="text" value={this.getObjectProperty("nomProjet")} onChange={this.handleChange.bind(this)} /></Col>
              </FormGroup>
            }

            {(idStatutParcelle === 5) &&
              <FormGroup controlId="motifParcelle">
                <Col componentClass={ControlLabel} sm={4}>Motif</Col>
                <Col sm={6}><Combobox id="motifParcelle" url={REST_API_URL + "motifparcelle/"} optionValueKey="idMotifParcelle" optionLabelKey="libelle"
                  default={idMotifParcelle} onChange={this.handleMotifParcelleSelect.bind(this)} placeholder="Motif" /></Col>
              </FormGroup>
            }

            <FormGroup controlId="sensibilite">
              <Col componentClass={ControlLabel} sm={4}>Sensibilité</Col>
              <Col sm={6}><Combobox id="sensibilite" url={REST_API_URL + "sensibilites/"} optionValueKey="idSensibilite" optionLabelKey="libelle"
                default={idSensibilite} onChange={this.handleSensibiliteSelect.bind(this)} placeholder="Sensibilité" /></Col>
            </FormGroup>

            <FormGroup controlId="regimeJuridique">
              <Col componentClass={ControlLabel} sm={4}>Régime juridique</Col>
              <Col sm={6}><Combobox id="regimeJuridique" url={REST_API_URL + "regimejuridiques/"} optionValueKey="idRegimeJuridique" optionLabelKey="libelle"
                default={idRegimeJuridique} onChange={this.handleRegimeJuridiqueSelect.bind(this)} placeholder="Régime juridique" /></Col>
            </FormGroup>

            <FormGroup controlId="proprietaire">
              <Col componentClass={ControlLabel} sm={4}>Propriétaire</Col>
              <Col sm={6}><Combobox id="proprietaire" url={REST_API_URL + "proprietaires/"} optionValueKey="idProprietaire" optionLabelKey="libelle"
                default={idProprietaire} onChange={this.handleProprietaireSelect.bind(this)} placeholder="Propriétaire" /></Col>
            </FormGroup>

            {/* Submit button */}
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.handleSubmit.bind(this)}>Valider</Button>
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
	}

  /**
  * handleSubmit
  * Handle form submit
  **/
  handleSubmit() {
    let obj = this.state.object;
    if(obj.statutParcelle) {
      if(obj.statutParcelle.idStatutParcelle !== 4) obj.nomProjet = null;
      if(obj.statutParcelle.idStatutParcelle !== 5) obj.motifParcelle = null;
    }

    this.initialValue = cloneObject(obj);
    this.onHide();
    const contrat = this.props.contrat;
    let contratState = contrat.state;
    contratState.object.infoParcelle = obj;
  }

  /**
  * handleChange
  * Modify the state from a field change
  **/
  handleChange(e) {
    let objState = this.state;
    objState.object[e.target.id] = e.target.value;
    this.setState(objState);
  }

  /**
  * handleStatutParcelleSelect
  * Handle statut select
  **/
  handleStatutParcelleSelect(statutParcelle) {
    let state = this.state;
    state.object.statutParcelle = statutParcelle;
    this.setState(state);
  }

  /**
  * handleMotifParcelleSelect
  * Handle motif select
  **/
  handleMotifParcelleSelect(motifParcelle) {
    let state = this.state;
    state.object.motifParcelle = motifParcelle;
    this.setState(state);
  }

  /**
  * handleRegimeJuridiqueSelect
  * Handle regime juridique select
  **/
  handleRegimeJuridiqueSelect(regimeJuridique) {
    let state = this.state;
    state.object.regimeJuridique = regimeJuridique;
    this.setState(state);
  }

  /**
  * handleSensibiliteSelect
  * Handle sensibilité select
  **/
  handleSensibiliteSelect(sensibilite) {
    let state = this.state;
    state.object.sensibilite = sensibilite;
    this.setState(state);
  }

  /**
  * handleProprietaireSelect
  * Handle propriétaire select
  **/
  handleProprietaireSelect(proprietaire) {
    let state = this.state;
    state.object.proprietaire = proprietaire;
    this.setState(state);
  }

  /**
  * onHide
  * Hide modal
  **/
  onHide() {
    this.setState({object: this.initialValue, hidden: true});
  }

  /**
  * show
  * Hide modal
  **/
  show() {
    this.setState({hidden: false});
  }

}
export default InfoParcelle;



// WEBPACK FOOTER //
// ./src/views/Entity/InfoParcelle.js